import React, { Component } from 'react';
import MachineDetailsView from '../views/MachineDetailsView';

class MachineDetailsContainer extends Component {
    render() {
        const { params } = this.props.match;
        return (
            <MachineDetailsView
                machineId={params.machineId}
                user={this.props.user}
                extraUser={this.props.extraUser}
            />
        );
    }
}

export default MachineDetailsContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineDetailsContainer.js